<div class="modal-header">
  <span class="popup-title header-num">{{ editMode ? 'Edit CI/CD Execution (1/2)' : 'Add New CI/CD Execution (1/2)' }}</span>
  <button type="button" class="cicd-close-btn" (click)="onCancel()" aria-label="Close">
    <i class="bi bi-x-circle"></i>
  </button>
</div>
<div class="right-panel-title-text" *ngIf="!isLoading">Selected Test Plans/Test Case List</div>

<div class="cicd-modal-body">

  <!-- ── Loading overlay ─────────────────────────────────────────────────── -->
  <div class="cicd-loading" *ngIf="isLoading">
    <div class="cicd-spinner"></div>
    <span>Loading test plans &amp; suites...</span>
  </div>

  <!-- ── Two-column layout ─────────────────────────────────────────────── -->
  <div class="cicd-layout" *ngIf="!isLoading">

    <div class="d-flex">
      <!-- ── LEFT PANEL: two sections ─────────────────────────────────────── -->
      <div class="cicd-left-panel">
        <div class="tree-search-wrap">
          <input type="text" class="form-control tree-search-input" placeholder="Search" [(ngModel)]="treeSearch"
            aria-label="Search test plans and suites" />
        </div>

        <!-- ── Scrollable sections ─────────────────────────────────────── -->
        <div class="cicd-sections-scroll">

        <!-- ── Section 1: Test Plans ──────────────────────────────────────── -->
        <div class="cicd-section">
          <button class="cicd-section-header" type="button" (click)="planSectionExpanded = !planSectionExpanded"
            [attr.aria-expanded]="planSectionExpanded">
            <i class="bi section-chevron" [ngClass]="planSectionExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
            <span class="section-label">Test Plans</span>
            <span class="section-count">
              <i class="bi bi-files"></i>
              {{ planNodes.length }}
            </span>
          </button>
          <div class="section-tree-area" *ngIf="planSectionExpanded">
            <app-tree-view [nodes]="filteredPlanNodes" [selectedNode]="selectedTreeNode!"
              [removeGreenLeftBorder]="false" [disableGroupHighlight]="false"
              (menuItemSelected)="onTreeNodeSelect($event)"></app-tree-view>
            <div class="tree-empty" *ngIf="filteredPlanNodes.length === 0">
              <span>No test plans found.</span>
            </div>
          </div>
        </div>

        <!-- ── Section 2: Test Suites & Test Cases ────────────────────────── -->
        <div class="cicd-section">
          <button class="cicd-section-header" type="button" (click)="suiteSectionExpanded = !suiteSectionExpanded"
            [attr.aria-expanded]="suiteSectionExpanded">
            <i class="bi section-chevron" [ngClass]="suiteSectionExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
            <span class="section-label">Test Suites &amp; Test Cases</span>
            <span class="section-count">
              <i class="bi bi-files"></i>
              {{ suiteCount }}
            </span>
          </button>
          <div class="section-tree-area" *ngIf="suiteSectionExpanded">
            <app-tree-view [nodes]="filteredSuiteNodes" [selectedNode]="selectedTreeNode!"
              [removeGreenLeftBorder]="false" [disableGroupHighlight]="false"
              (menuItemSelected)="onTreeNodeSelect($event)"></app-tree-view>
            <div class="tree-empty" *ngIf="filteredSuiteNodes.length === 0">
              <span>No test suites or test cases found.</span>
            </div>
          </div>
        </div>

        </div><!-- end cicd-sections-scroll -->
      </div>

      <!-- ── CENTRE: arrow buttons ─────────────────────────────────────────── -->
      <div class="cicd-arrows">
        <button class="arrow-btn" type="button" (click)="moveToRight()" [disabled]="!canMoveRight"
          title="Add to selected list" aria-label="Move to selected list">
          <img src="assets/images/virtusa-icons/arrow-right.svg" alt="Move right" class="arrow-icon" />
        </button>

        <button class="arrow-btn" type="button" (click)="moveToLeft()" [disabled]="!canMoveLeft"
          title="Remove from selected list" aria-label="Remove from selected list">
          <img src="assets/images/virtusa-icons/arrow-left.svg" alt="Move left" class="arrow-icon" />
        </button>
      </div>
    </div>

    <!-- ── RIGHT PANEL: selected sections ───────────────────────────────── -->
    <div class="cicd-right-panel">

      <!-- Empty state -->
      <div class="right-empty" *ngIf="accordionSections.length === 0">
        <img src="assets/images/virtusa-icons/insert-row.svg" alt="empty" class="right-empty-icon" />
        <p class="right-empty-text">
          Select a test plan or suite on the left and click the arrow to add it here.
        </p>
      </div>

      <!-- Accordion table with range + Set as Default toolbar -->
      <div class="right-content" *ngIf="accordionSections.length > 0">
        <app-accordion-table-view [sections]="accordionSections" [itemLabel]="'Test Cases'"
          [paginationInfo]="paginationInfo" [showHeader]="true" [showTestPlanHeader]="true" [showSelectAll]="false"
          [showPagination]="accordionSections.length > 1" [dropdown1Options]="executionEngineOptions"
          [dropdown1Config]="{ iconType: 'assetImage', placeholderText: 'Execution engine' }"
          [dropdown1RowKey]="'executionEngine'" [dropdown2Options]="browserOptions" [dropdown2RowKey]="'browser'"
          (switchToggle)="onSwitchToggle($event)" (dropdown1Change)="onExecutionEngineChange($event)"
          (dropdown2Change)="onBrowserChange($event)"
          (tableActions)="onTableActions($event)"></app-accordion-table-view>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer d-flex justify-content-end">
  <button type="button" class="btn btn-accello-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-accello-primary-light d-flex align-items-center gap-2" (click)="onNext()"
    [disabled]="isSubmitting || accordionSections.length === 0">
    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Next
  </button>
</div>